<template>
  <div class="messaging-home">
    <!-- Cabeçalho -->
    <div class="flex items-center justify-between px-8 py-3 shrink-0 bg-white messaging-header">
      <div class="flex items-center gap-3 tw-text-lg" style="padding-left: 16px;">
        <span class="text-2xl text-[#707070]">{{ $gettext('MESSAGING') }}</span>
      </div>

      <!-- Barra de ferramentas -->
      <div class="flex">
        <button
          v-for="tool in tools"
          :key="tool.key"
          :class="['toolbar-btn', { active: tool.key === currentTool }]"
          @click="currentTool = tool.key"
        >
          <span class="toolbar-icon" v-if="tool.icon">
            <q-icon :name="tool.icon" size="20px" />
          </span>
          {{ tool.label }}
        </button>
      </div>
    </div>

    <!-- Conteúdo dinâmico -->
    <div class="messaging-content">
      <component :is="currentComponent" :interface="currentInterface" :title="currentLabel" :name="currentLabel" />
    </div>
  </div>
</template>

<script>
import { getText } from '@tiptap/core'

export default {
  name: 'MessagingHome',
  components: {
    // Lazy load padrão Vue 2
    MessagingDashboard: () => import('../dasboard/MessagingDashboard.vue'),
    Template: () => import('../template/Template.vue'),
    MsgCampaign: () => import('../campaign/Campaign.vue')
  },
  data () {
    return {
      currentTool: 'dashboard',
      tools: [
        { key: 'dashboard', label: this.$gettext('DASHBOARD'), icon: 'dashboard', component: 'MessagingDashboard' },
        { key: 'template', label: this.$gettext('TEMPLATES'), icon: 'description', component: 'Template', interface: 'template.pesquisar' },
        { key: 'campaign', label: this.$gettext('CAMPAIGNS'), icon: 'rss_feed', component: 'MsgCampaign', interface: 'campaign.pesquisar' }
      ]
    }
  },
  computed: {
    currentComponent () {
      const found = this.tools.find(t => t.key === this.currentTool)
      return found ? found.component : null
    },
    currentLabel () {
      const found = this.tools.find(t => t.key === this.currentTool)
      return found ? found.label : ''
    },
    currentInterface () {
      const found = this.tools.find(t => t.key === this.currentTool)
      return found ? found.interface : null
    }
  }
}
</script>

<style lang="stylus" scoped>
.messaging-header {
  border-bottom: 1px solid #ececec;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  padding: 0 16px;
  min-width: 160px;
  justify-content: center;
  border: 1px solid #e0e0e0;
  background: #f5f5f5;
  color: #707070;
  border-radius: 0;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  outline: none;
  border-left-width: 0;
  transition: background 0.2s, color 0.2s;
}
.toolbar-btn:first-child {
  border-radius: 6px 0 0 6px;
  border-left-width: 1px;
}
.toolbar-btn.active,
.toolbar-btn:active {
  background: #0e88e4;
  color: #fff;
  z-index: 1;
}
.toolbar-btn:not(:first-child) {
  border-radius: 0;
}
.toolbar-btn:last-child {
  border-radius: 0 6px 6px 0;
}
.messaging-content {
  padding: 32px;
  background: #fafbfc;
  min-height: 400px;
}
</style>
